import { useLayoutEffect } from 'react'
import { useNavigate, useLocation } from 'react-router'

import { useSeller } from '@/contexts/seller'

const RedirectRules = () => {
  const { isRegisteredWithoutMainPhoneNumber } = useSeller()
  const location = useLocation()
  const navigate = useNavigate()

  const redirectToEditPocInfo =
    isRegisteredWithoutMainPhoneNumber &&
    !location.pathname.includes('/edit-poc-info')

  useLayoutEffect(() => {
    if (redirectToEditPocInfo) {
      void navigate('/my-account/edit-poc-info')
    }
  }, [navigate, redirectToEditPocInfo])

  return null
}

export default RedirectRules
